import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';

// import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, importProvidersFrom } from '@angular/core';
import { MAT_FAB_DEFAULT_OPTIONS } from '@angular/material/button';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideRouter, Router, Routes } from '@angular/router';
import { ScriptLoaderService } from './app/script-loader.service';
import { ConfigService } from './services/config.service';
import { TranslationService } from './services/translation.service';
import { CoordinatorModule } from 'coordinator';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from './app/date-adapter';
import { UrlParserComponent } from './app/url-parser/url-parser.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

function showPreload() {
    const loaderInside = document.createElement('div');
    const preloader = document.createElement('div');
    const img = document.createElement('img');
    const loaderDiv = document.createElement('div');
    const span = document.createElement('span');
    span.textContent = 'Loading...';
    img.className = 'img_loader';

    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';

    preloader.className = 'loader_center_memowl';
    preloader.id = 'preloader_memowl';
    document.body.style.setProperty('background-color', 'rgb(0, 0, 201)', 'important');

    loaderInside.className = 'loader_inside_memowl';

    img.src = !environment.alias.includes('prod')
        ? './assets/memowl_vertical_logo_beta.png'
        : './assets/memowl_vertical_logo.png';

    span.className = 'text_loader_memowl';

    loaderDiv.className = 'loader_memowl';

    loaderInside.appendChild(img);
    loaderInside.appendChild(loaderDiv);
    loaderInside.appendChild(span);
    preloader.appendChild(loaderInside);

    favicon.href = 'mowl_favicon.ico';

    document.head.appendChild(favicon);
    document.body.appendChild(preloader);
}

function initSentry() {
    const { sentryDsn } = environment;

    if (sentryDsn?.trim()?.length > 0) {
        Sentry.init({
            dsn: sentryDsn,
            integrations: [Sentry.replayIntegration()],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });

        console.log(`Sentry initialized for ${environment.alias}`);
    }
}

initSentry();
showPreload();

const routes: Routes = [
    {
        path: 'pid/:value',
        component: UrlParserComponent,
        resolve: {},
    },
    {
        path: 'p/:value',
        component: UrlParserComponent,
    },
    {
        path: 'pc/:value',
        component: UrlParserComponent,
    },
    {
        path: 'apiLoad/:value',
        component: UrlParserComponent,
        resolve: {},
    },

    {
        path: 'cpn/:cpn',
        component: UrlParserComponent,
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(CoordinatorModule.forRoot(environment)),
        importProvidersFrom(HttpClientModule),
        importProvidersFrom(NoopAnimationsModule),
        provideRouter(routes),
        ScriptLoaderService,
        TranslationService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeTranslations,
            deps: [TranslationService, HttpClient],
            multi: true,
        },
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeConfig,
            deps: [ConfigService, HttpClient],
            multi: true,
        },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 1000 } },
        {
            provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
            useValue: { color: 'primary' },
        },
        {
            provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
            useValue: { color: 'primary' },
        },
        { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
        { provide: MAT_FAB_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
        },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
    ],
}).catch((err) => console.error(err));

export function initializeTranslations(translationService: TranslationService, http: HttpClient) {
    return () => translationService.initializeTranslations(http);
}

export function initializeConfig(configService: ConfigService, http: HttpClient) {
    return () => configService.getRemoteConfig(http);
}
